import { TasksOptions, TaskStatusWidget } from '@apps-common/apps/portal/pages/units/pages/program-tasks/components'
import { commonIcons } from '@apps-common/config/icons'
import { toLocalTimestampStr } from '@apps-common/helpers/to-local-timestamp'
import { IAppNavigation } from '@apps-common/hooks/useNavigation'
import { IUnitTaskGroupsFilterState } from '@apps-common/stores/useUnitTaskGroupsFilterStore'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export const buildTableKeys = (navigation: IAppNavigation, filter: IUnitTaskGroupsFilterState) => [
  {
    title: 'Name',
    key: 'taskGroupName',
    changeable: true,
    thClasses: '',
    tdClasses: '',
    Component: (props: IUnitTaskGroupModel) => <div className='capitalize'>{props?.taskGroupName || '<No name>'}</div>
  },
  {
    title: 'Status',
    key: 'status',
    changeable: true,
    noCopy: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <TaskStatusWidget status={props.status} />
  },
  {
    title: 'Type',
    key: 'taskType',
    changeable: true,
    noCopy: true,
    thClasses: 'hidden lg:table-cell min-w-[100px]',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => (
      <div className='capitalize'>{props.taskType ? props.taskType?.split('_')?.join('') : '<Unknown>'}</div>
    )
  },
  {
    title: 'Queue',
    key: 'queueCount',
    changeable: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{props.queueCount || 0} device(s)</div>
  },
  {
    title: 'Description',
    key: 'description',
    changeable: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{props.description}</div>
  },
  {
    title: 'RunsAt',
    key: 'runAt',
    changeable: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{props.runAt ? toLocalTimestampStr(props.runAt) : <commonIcons.dash />}</div>
  },
  {
    title: 'CompletedAt',
    key: 'completedAt',
    changeable: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => (
      <div>{props.completedAt ? toLocalTimestampStr(props.completedAt) : <commonIcons.dash />}</div>
    )
  },

  // optional
  {
    title: 'AddedAt',
    key: 'addedAt',
    optional: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{toLocalTimestampStr(props.addedAt)}</div>
  },
  {
    title: 'AddedBy',
    key: 'addedBy',
    optional: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{props.addedBy}</div>
  },
  {
    title: 'UpdatedAt',
    key: 'updatedAt',
    optional: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{toLocalTimestampStr(props.updatedAt)}</div>
  },
  {
    title: 'UpdatedBy',
    key: 'updatedBy',
    optional: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{props.updatedBy}</div>
  },
  {
    title: 'Pending',
    key: 'pendingCount',
    optional: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{props.pendingCount || 0} device(s)</div>
  },
  {
    title: 'Processing',
    key: 'processingCount',
    optional: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{props.processingCount || 0} device(s)</div>
  },
  {
    title: 'Failed',
    key: 'failedCount',
    optional: true,
    thClasses: 'hidden lg:table-cell',
    tdClasses: 'hidden lg:table-cell',
    Component: (props: IUnitTaskGroupModel) => <div>{props.failedCount || 0} device(s)</div>
  },
  //
  // optional -end
  //
  {
    title: 'Actions',
    key: 'actions',
    static: true,
    thClasses: 'text-right ',
    tdClasses: '',
    Component: (props: IUnitTaskGroupModel) => <TasksOptions task={props} navigation={navigation} />
  }
]
